import { createSelector } from 'reselect';
import { IDENTITY_NAMESPACE } from './constants';
import { stateSelector } from '../stateSelector';

export const identityStateSelector = createSelector(
  stateSelector,
  state => state[IDENTITY_NAMESPACE] ?? {},
);
